import React from 'react';
import pluralize from 'pluralize';
import { Badge, Button, Col, Media, Panel, PanelGroup, Row } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import Ordinal from '../../shared/Ordinal';

const LoadReport = ({ loadReport, onSkipItem, showConsolidatedLoad }) => {
  if (!loadReport.length) {
    return <blockquote>No deliveries are scheduled today</blockquote>;
  }

  return (
    <div>
      <blockquote>
        The load report lists deliveries grouped by equipment.
        Material is grouped by delivery in reverse order.
        Clicking the equipment name will collapse the equipment for easier viewing.
      </blockquote>
      <PanelGroup>
        {loadReport.map(e => (
          <Panel
            defaultExpanded
            eventKey={e.equipment.id}
            key={e.equipment.id}
          >
            <Panel.Toggle componentClass={Panel.Heading}>
              {e.equipment.name}
            </Panel.Toggle>
            <Panel.Collapse>
              <Panel.Body>
                <Row>
                  <Col md={6}>
                    <h3>Original Load</h3>
                    {e.purchaseOrders.map((p, i, a) => (
                      <Media key={p.id}>
                        <Media.Body>
                          <Media.Heading>
                            <Badge><Ordinal value={a.length - i}/> Stop</Badge> {p.poNumber}
                          </Media.Heading>
                          <ul>
                            {p.items.map(i => (
                              <li key={i.id}>
                                <input type="checkbox"/> {i.item.name}: {i.quantity} {pluralize(i.item.itemType.inventoryQuantityLabel || '')}
                              </li>
                            ))}
                          </ul>
                        </Media.Body>
                      </Media>
                    ))}
                  </Col>
                  {showConsolidatedLoad && (
                    <Col md={6}>
                      <h3>Conslidated Load</h3>
                      {e.consolidatedLoad.map((p, i, a) => (
                        <Media key={p.id}>
                          <Media.Body>
                            <Media.Heading>
                              <Badge><Ordinal value={a.length - i}/> Stop</Badge> {p.poNumber}
                            </Media.Heading>
                            <ul>
                              {p.items.map(i => (
                                <li key={`${i.id}-${i.item.id}`}>
                                  <input type="checkbox"/> {i.consolidated && (
                                    <Button bsSize="xs" bsStyle="danger" onClick={() => onSkipItem(i.id)}>
                                      <FontAwesome name="times" />
                                    </Button>
                                  )}
                                  <span>{i.item.name}: {i.quantity} {pluralize(i.item.itemType.inventoryQuantityLabel || '')}</span>
                                </li>
                              ))}
                            </ul>
                          </Media.Body>
                        </Media>
                      ))}
                    </Col>
                  )}
                </Row>
              </Panel.Body>
            </Panel.Collapse>
          </Panel>
        ))}
      </PanelGroup>
    </div>
  );
};

export default LoadReport;
